module.exports = "../fonts/whatsapp_enter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp_enter.svg
// module id = 94
// module chunks = 0